/** -1 = illimité (Enterprise) */
export const UNLIMITED_QUOTA = -1;

export interface Quota {
  users: number;
  employees: number;
  storageGb: number;
  apiCallsPerMonth: number;
}

export function isUnlimited(value: number): boolean {
  return value === UNLIMITED_QUOTA;
}
